export default __webpack_public_path__ + "static/media/allery-2.60594d2f.svg";